module.exports = __webpack_public_path__ + "static/media/swiggylogo.60cb5a74.png";